import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import _ from "lodash";
import { selectArticlesMap } from "./selectArticlesMap";
import { selectArticlegroupsMap } from "./selectArticlegroupsMap";

export const selectArticlegroupArticlesMap = createSelector(
  [(state: RootState) => state.menuData.menukaart_products, selectArticlesMap, selectArticlegroupsMap],
  (menukaartProducts, articlesMap, articlegroupsMap) => {
    const articlegroupArticlesMap: PartialRecord<string, Record<string, boolean>> = {};
    menukaartProducts
      .filter((entry) => articlesMap[entry.product_id] && articlegroupsMap[entry.menukaart_id])
      .forEach((menukaartProduct) => {
        if (!articlegroupArticlesMap[menukaartProduct.menukaart_id]) {
          articlegroupArticlesMap[menukaartProduct.menukaart_id] = {};
        }
        const record = articlegroupArticlesMap[menukaartProduct.menukaart_id];
        if (record) {
          record[menukaartProduct.product_id] = true;
        }
      });

    return _.chain(articlegroupArticlesMap)
      .mapValues((record) => {
        return _.keys(record).sort((a, b) => (articlesMap[a]?.sortKey ?? 0) - (articlesMap[b]?.sortKey ?? 0));
      })
      .value();
  }
);
